module.exports = __webpack_public_path__ + "img/oficina2.18cc0d3f.svg";